<template>
  <div id="app">
    <navbar/>
    <router-view/>
    <cookie-modal />
    <foot/>
  </div>
</template>

<style>

</style>
<script>
  import Navbar from "./components/shared/navbar";
  import Foot from "./components/shared/foot";
  import cookieModal from "./components/Notices/cookieModal";
  export default {
    components: {Foot, Navbar, cookieModal}
  }

/*
  jQuery(function($) {
    if (sessionStorage.getItem('ModalInfo') !== 'true') {
      setTimeout(() => UIkit.modal('#myModal').show(), 4000 );
      sessionStorage.setItem('ModalInfo', 'true')
    }
  });
*/


</script>